import React, { useState } from "react";
import "../../scss/layout/slidermodal.scss";

const categories = [
  "Airfreight",
  "Automotive & Agricultural",
  "CEP Services",
  "Consumer Goods",
  "Contract Logistics",
  "Custom Logistics",
  "Marine & Cruise",
  "Perishables",
  "RailFreight",
  "SeaFreight",
  "RoadFreight",
  "Technology",
];

const ExpertiseModal = ({ setShowServiceModal }) => {
  // ✅ Prop correctly received
  const [selectedIndex, setSelectedIndex] = useState(0); // ✅ Only local state needed

  // Scroll Up
  const handleUp = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === 0 ? categories.length - 1 : prevIndex - 1
    );
  };

  // Scroll Down
  const handleDown = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === categories.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="modal-container">
      <div className="modal">
        <h2>We are Experts in</h2>

        <div className="slider">
          <button className="arrow up" onClick={handleUp}>
            ▲
          </button>

          <div className="dropdown">
            {categories.map((category, index) => (
              <p
                key={index}
                className={selectedIndex === index ? "active" : ""}
              >
                {category}
              </p>
            ))}
          </div>

          <button className="arrow down" onClick={handleDown}>
            ▼
          </button>

          {/* ✅ Now the close button will work properly */}
          <button
            className="close-modal"
            onClick={() => setShowServiceModal(false)} // Now it correctly updates the parent state
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExpertiseModal;
